import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/statement-no-data.svg";
var StatementNoDataSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  StatementNoDataSolid_default as default
};
